function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_52518_48321)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.8359 5.979H46.6586C48.3273 5.979 49.8349 6.37724 51.1813 7.1737C52.5466 7.9512 53.6179 9.07954 54.3956 10.5587C55.1919 12.0379 55.5903 13.773 55.5903 15.7642C55.5903 17.8881 55.2016 19.7181 54.4239 21.2542C53.6466 22.7712 52.5749 23.928 51.2096 24.7245C49.8633 25.502 48.3463 25.8907 46.6586 25.8907H38.8359V5.979ZM46.2603 22.5057C47.7963 22.5057 49.0669 21.9368 50.0719 20.799C51.0769 19.6612 51.5796 17.9829 51.5796 15.7642C51.5796 14.3988 51.3426 13.2326 50.8683 12.2654C50.3943 11.2983 49.7496 10.5777 48.9339 10.1036C48.1376 9.61054 47.2463 9.364 46.2603 9.364H42.7899V22.5057H46.2603Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.3951 14.6268C63.5984 14.6268 62.9631 14.9586 62.4891 15.6224C62.0151 16.2861 61.7781 17.0636 61.7781 17.9549V25.8911H58.1084V11.5547H61.7781V13.4321C62.0624 12.8252 62.4511 12.3606 62.9441 12.0383C63.4374 11.7159 64.0157 11.5547 64.6794 11.5547H66.4431V14.6268H64.3951Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M68.4428 11.5544H72.1124V25.8909H68.4428V11.5544ZM72.2831 5.72314V9.47791H68.3291V5.72314H72.2831Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.6688 14.6266H73.9951V11.5545H76.6688V9.59177C76.6688 8.22637 77.0101 7.1834 77.6928 6.46277C78.3758 5.74217 79.3521 5.38184 80.6228 5.38184H84.1215V8.45394H81.8461C81.3341 8.45394 80.9548 8.5867 80.7081 8.85217C80.4618 9.0987 80.3385 9.5159 80.3385 10.1038V11.5545H84.4061V14.6266H80.3385V25.8909H76.6688V14.6266Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.4787 6.54785V11.5543H95.3474V14.6264H91.4787V21.2541C91.4787 22.2971 91.9531 22.8186 92.9011 22.8186H95.2621V25.8907H91.8201C90.5307 25.8907 89.5351 25.5494 88.8334 24.8667C88.1507 24.165 87.8094 23.0936 87.8094 21.6524V14.6264H85.1357V11.5543H87.8094V8.08392L91.4787 6.54785Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2886 25.4614C22.2886 26.5054 21.8996 27.4207 21.2751 28.1228C21.2678 28.131 21.2626 28.1411 21.2604 28.152C21.251 28.1969 21.2912 28.2364 21.3357 28.2254C23.1364 27.7817 24.5923 26.2436 24.5923 24.2237V13.7525C24.5923 10.6571 22.8634 7.7969 20.0568 6.24923L8.72436 0L6.47949 1.27019L17.7531 7.48693C20.5596 9.03463 22.2886 11.8949 22.2886 14.9902V25.4614Z",
  fill: "url(#paint0_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2886 25.4614C22.2886 26.5054 21.8996 27.4207 21.2751 28.1228C21.2678 28.131 21.2626 28.1411 21.2604 28.152C21.251 28.1969 21.2912 28.2364 21.3357 28.2254C23.1364 27.7817 24.5923 26.2436 24.5923 24.2237V13.7525C24.5923 10.6571 22.8634 7.7969 20.0568 6.24923L8.72436 0L6.47949 1.27019L17.7531 7.48693C20.5596 9.03463 22.2886 11.8949 22.2886 14.9902V25.4614Z",
  fill: "url(#paint1_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2886 25.4614C22.2886 26.5054 21.8996 27.4207 21.2751 28.1228C21.2678 28.131 21.2626 28.1411 21.2604 28.152C21.251 28.1969 21.2912 28.2364 21.3357 28.2254C23.1364 27.7817 24.5923 26.2436 24.5923 24.2237V13.7525C24.5923 10.6571 22.8634 7.7969 20.0568 6.24923L8.72436 0L6.47949 1.27019L17.7531 7.48693C20.5596 9.03463 22.2886 11.8949 22.2886 14.9902V25.4614Z",
  fill: "url(#paint2_radial_52518_48321)",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2886 25.4614C22.2886 26.5054 21.8996 27.4207 21.2751 28.1228C21.2678 28.131 21.2626 28.1411 21.2604 28.152C21.251 28.1969 21.2912 28.2364 21.3357 28.2254C23.1364 27.7817 24.5923 26.2436 24.5923 24.2237V13.7525C24.5923 10.6571 22.8634 7.7969 20.0568 6.24923L8.72436 0L6.47949 1.27019L17.7531 7.48693C20.5596 9.03463 22.2886 11.8949 22.2886 14.9902V25.4614Z",
  fill: "url(#paint3_radial_52518_48321)",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.2886 25.4614C22.2886 26.5054 21.8996 27.4207 21.2751 28.1228C21.2678 28.131 21.2626 28.1411 21.2604 28.152C21.251 28.1969 21.2912 28.2364 21.3357 28.2254C23.1364 27.7817 24.5923 26.2436 24.5923 24.2237V13.7525C24.5923 10.6571 22.8634 7.7969 20.0568 6.24923L8.72436 0L6.47949 1.27019L17.7531 7.48693C20.5596 9.03463 22.2886 11.8949 22.2886 14.9902V25.4614Z",
  fill: "url(#paint4_linear_52518_48321)",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1206 27.249V16.7778C19.1206 13.6825 17.3916 10.8222 14.5851 9.27454L3.31152 3.05779L5.55641 1.7876L16.8888 8.03681C19.6954 9.58451 21.4243 12.4447 21.4243 15.5401V26.0113C21.4243 28.0311 19.9684 29.5693 18.1677 30.013C18.1232 30.024 18.083 29.9844 18.0924 29.9396C18.0947 29.9287 18.0998 29.9186 18.1071 29.9103C18.7316 29.2083 19.1206 28.293 19.1206 27.249Z",
  fill: "url(#paint5_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1206 27.249V16.7778C19.1206 13.6825 17.3916 10.8222 14.5851 9.27454L3.31152 3.05779L5.55641 1.7876L16.8888 8.03681C19.6954 9.58451 21.4243 12.4447 21.4243 15.5401V26.0113C21.4243 28.0311 19.9684 29.5693 18.1677 30.013C18.1232 30.024 18.083 29.9844 18.0924 29.9396C18.0947 29.9287 18.0998 29.9186 18.1071 29.9103C18.7316 29.2083 19.1206 28.293 19.1206 27.249Z",
  fill: "url(#paint6_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1206 27.249V16.7778C19.1206 13.6825 17.3916 10.8222 14.5851 9.27454L3.31152 3.05779L5.55641 1.7876L16.8888 8.03681C19.6954 9.58451 21.4243 12.4447 21.4243 15.5401V26.0113C21.4243 28.0311 19.9684 29.5693 18.1677 30.013C18.1232 30.024 18.083 29.9844 18.0924 29.9396C18.0947 29.9287 18.0998 29.9186 18.1071 29.9103C18.7316 29.2083 19.1206 28.293 19.1206 27.249Z",
  fill: "url(#paint7_radial_52518_48321)",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1206 27.249V16.7778C19.1206 13.6825 17.3916 10.8222 14.5851 9.27454L3.31152 3.05779L5.55641 1.7876L16.8888 8.03681C19.6954 9.58451 21.4243 12.4447 21.4243 15.5401V26.0113C21.4243 28.0311 19.9684 29.5693 18.1677 30.013C18.1232 30.024 18.083 29.9844 18.0924 29.9396C18.0947 29.9287 18.0998 29.9186 18.1071 29.9103C18.7316 29.2083 19.1206 28.293 19.1206 27.249Z",
  fill: "url(#paint8_radial_52518_48321)",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1206 27.249V16.7778C19.1206 13.6825 17.3916 10.8222 14.5851 9.27454L3.31152 3.05779L5.55641 1.7876L16.8888 8.03681C19.6954 9.58451 21.4243 12.4447 21.4243 15.5401V26.0113C21.4243 28.0311 19.9684 29.5693 18.1677 30.013C18.1232 30.024 18.083 29.9844 18.0924 29.9396C18.0947 29.9287 18.0998 29.9186 18.1071 29.9103C18.7316 29.2083 19.1206 28.293 19.1206 27.249Z",
  fill: "url(#paint9_linear_52518_48321)",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.93126L2.27412 3.64453L13.6065 9.89376C16.4131 11.4414 18.1421 14.3017 18.1421 17.397V27.9199L18.1418 27.9197C18.1031 31.0656 14.5269 33.0206 11.6628 31.4412L1.39186 25.7774L0 25.0296V4.93126ZM15.8383 18.6674V24.7463L8.20713 20.5381V9.45706L11.3028 11.1642C14.1094 12.7118 15.8383 15.5721 15.8383 18.6674ZM5.32743 7.86906L6.4793 8.50426V21.4903L6.60023 21.5552L15.8383 26.6495V27.8255L5.3423 22.0375L5.32743 22.0459V7.86906ZM3.45563 6.83686V23.0448L3.50977 23.0744L3.45563 23.105L15.8242 29.9256C15.7208 30.4696 15.071 30.7799 14.5424 30.4884L2.30375 23.7394V6.20166L3.45563 6.83686Z",
  fill: "url(#paint10_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.93126L2.27412 3.64453L13.6065 9.89376C16.4131 11.4414 18.1421 14.3017 18.1421 17.397V27.9199L18.1418 27.9197C18.1031 31.0656 14.5269 33.0206 11.6628 31.4412L1.39186 25.7774L0 25.0296V4.93126ZM15.8383 18.6674V24.7463L8.20713 20.5381V9.45706L11.3028 11.1642C14.1094 12.7118 15.8383 15.5721 15.8383 18.6674ZM5.32743 7.86906L6.4793 8.50426V21.4903L6.60023 21.5552L15.8383 26.6495V27.8255L5.3423 22.0375L5.32743 22.0459V7.86906ZM3.45563 6.83686V23.0448L3.50977 23.0744L3.45563 23.105L15.8242 29.9256C15.7208 30.4696 15.071 30.7799 14.5424 30.4884L2.30375 23.7394V6.20166L3.45563 6.83686Z",
  fill: "url(#paint11_linear_52518_48321)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.93126L2.27412 3.64453L13.6065 9.89376C16.4131 11.4414 18.1421 14.3017 18.1421 17.397V27.9199L18.1418 27.9197C18.1031 31.0656 14.5269 33.0206 11.6628 31.4412L1.39186 25.7774L0 25.0296V4.93126ZM15.8383 18.6674V24.7463L8.20713 20.5381V9.45706L11.3028 11.1642C14.1094 12.7118 15.8383 15.5721 15.8383 18.6674ZM5.32743 7.86906L6.4793 8.50426V21.4903L6.60023 21.5552L15.8383 26.6495V27.8255L5.3423 22.0375L5.32743 22.0459V7.86906ZM3.45563 6.83686V23.0448L3.50977 23.0744L3.45563 23.105L15.8242 29.9256C15.7208 30.4696 15.071 30.7799 14.5424 30.4884L2.30375 23.7394V6.20166L3.45563 6.83686Z",
  fill: "url(#paint12_radial_52518_48321)",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.93126L2.27412 3.64453L13.6065 9.89376C16.4131 11.4414 18.1421 14.3017 18.1421 17.397V27.9199L18.1418 27.9197C18.1031 31.0656 14.5269 33.0206 11.6628 31.4412L1.39186 25.7774L0 25.0296V4.93126ZM15.8383 18.6674V24.7463L8.20713 20.5381V9.45706L11.3028 11.1642C14.1094 12.7118 15.8383 15.5721 15.8383 18.6674ZM5.32743 7.86906L6.4793 8.50426V21.4903L6.60023 21.5552L15.8383 26.6495V27.8255L5.3423 22.0375L5.32743 22.0459V7.86906ZM3.45563 6.83686V23.0448L3.50977 23.0744L3.45563 23.105L15.8242 29.9256C15.7208 30.4696 15.071 30.7799 14.5424 30.4884L2.30375 23.7394V6.20166L3.45563 6.83686Z",
  fill: "url(#paint13_radial_52518_48321)",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 4.93126L2.27412 3.64453L13.6065 9.89376C16.4131 11.4414 18.1421 14.3017 18.1421 17.397V27.9199L18.1418 27.9197C18.1031 31.0656 14.5269 33.0206 11.6628 31.4412L1.39186 25.7774L0 25.0296V4.93126ZM15.8383 18.6674V24.7463L8.20713 20.5381V9.45706L11.3028 11.1642C14.1094 12.7118 15.8383 15.5721 15.8383 18.6674ZM5.32743 7.86906L6.4793 8.50426V21.4903L6.60023 21.5552L15.8383 26.6495V27.8255L5.3423 22.0375L5.32743 22.0459V7.86906ZM3.45563 6.83686V23.0448L3.50977 23.0744L3.45563 23.105L15.8242 29.9256C15.7208 30.4696 15.071 30.7799 14.5424 30.4884L2.30375 23.7394V6.20166L3.45563 6.83686Z",
  fill: "url(#paint14_linear_52518_48321)",
  fillOpacity: 0.2
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52518_48321",
  x1: -0.409298,
  y1: 16,
  x2: 24.318,
  y2: 13.7894,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3873"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473958,
  stopColor: "#711EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3FE5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_52518_48321",
  x1: 1.5244,
  y1: 1.47271,
  x2: 18.788,
  y2: 16.1388,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6F063"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E07774",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.648549 11.2488) rotate(65.584) scale(7.16837 6.1515)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.925861,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.22023 8.28123) rotate(59.0024) scale(4.54987 6.21407)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0864251,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94115,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_52518_48321",
  x1: 2.81543,
  y1: 8.88807,
  x2: 15.6274,
  y2: 13.411,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_52518_48321",
  x1: -0.409614,
  y1: 15.9998,
  x2: 24.3177,
  y2: 13.7892,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3873"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473958,
  stopColor: "#711EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3FE5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_52518_48321",
  x1: 1.52409,
  y1: 1.47249,
  x2: 18.7877,
  y2: 16.1385,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6F063"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E07774",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.648234 11.2486) rotate(65.584) scale(7.16837 6.1515)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.925861,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.21991 8.28101) rotate(59.0024) scale(4.54987 6.21407)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0864251,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94115,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_52518_48321",
  x1: 2.81512,
  y1: 8.88784,
  x2: 15.627,
  y2: 13.4108,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_52518_48321",
  x1: -0.40949,
  y1: 16.0001,
  x2: 24.3178,
  y2: 13.7896,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3873"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473958,
  stopColor: "#711EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3FE5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_52518_48321",
  x1: 1.52421,
  y1: 1.47284,
  x2: 18.7878,
  y2: 16.1389,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6F063"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E07774",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0.648357 11.249) rotate(65.584) scale(7.16837 6.1515)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.925861,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_52518_48321",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.22003 8.28136) rotate(59.0024) scale(4.54987 6.21407)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0864251,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.94115,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_52518_48321",
  x1: 2.81524,
  y1: 8.8882,
  x2: 15.6272,
  y2: 13.4112,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_52518_48321"
}, /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 32,
  fill: "white"
})));

function SvgDrift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 32,
    viewBox: "0 0 96 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrift);
export default __webpack_public_path__ + "static/media/Drift.5df36a8f446d714871da1e62233b7b18.svg";
export { ForwardRef as ReactComponent };